/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OEPPaymentMethod {
  SELF_PAY = 'SELF_PAY',
  ZORRO_PAY = 'ZORRO_PAY',
}
